import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { addProduct } from "../Redux/Features/ProductsPage/actions";
import Navbar from "./Navbar";
import SingleProduct from "./SingleProduct";

const Products = () => {
 const allProducts = useSelector((state) => state.allProducts);
 const dispatch = useDispatch();
 const handleFormSubmit = (e) => {
  e.preventDefault();
  let prodObj = {
   name: e.target.productName.value,
   category: e.target.category.value,
   prodImg: e.target.prodImg.value,
   prodPrice: e.target.prodPrice.value,
   prodQuantity: e.target.prodQuantity.value,
  };
  dispatch(addProduct(prodObj));
  e.target.productName.value = "";
  e.target.category.value = "";
  e.target.prodImg.value = "";
  e.target.prodPrice.value = "";
  e.target.prodQuantity.value = "";
 };

 return (
  <div>
   {/* <!-- Navbar --> */}
   <Navbar />
   {/* <!-- Navbar ends --> */}
   <main className="py-16">
    <div className="productWrapper">
     {/* <!-- products container --> */}
     <div className="productContainer" id="lws-productContainer">
      {/* <!-- product item --> */}
      {allProducts.length > 0 ? (
       allProducts.map((product) => (
        <SingleProduct key={product.id} prod={product} />
       ))
      ) : (
       <h4>no product found</h4>
      )}

      {/* <!-- product item ends --> */}
     </div>
     {/* <!-- products container ends --> */}
     <div>
      {/* <!-- Product Input Form --> */}
      <div className="formContainer">
       <h4 className="formTitle">Add New Product</h4>
       <form
        className="space-y-4 text-[#534F4F]"
        onSubmit={handleFormSubmit}
        id="lws-addProductForm"
       >
        {/* <!-- product name --> */}
        <div className="space-y-2">
         <label htmlFor="name">Product Name</label>
         <input
          className="addProductInput"
          id="lws-inputName"
          type="text"
          name="productName"
          required
         />
        </div>
        {/* <!-- product category --> */}
        <div className="space-y-2">
         <label htmlFor="category">Category</label>
         <input
          className="addProductInput"
          id="lws-inputCategory"
          type="text"
          name="category"
          required
         />
        </div>
        {/* <!-- product image url --> */}
        <div className="space-y-2">
         <label htmlFor="image">Image Url</label>
         <input
          className="addProductInput"
          id="lws-inputImage"
          type="text"
          name="prodImg"
          required
         />
        </div>
        {/* <!-- price & quantity container --> */}
        <div className="grid grid-cols-2 gap-8 pb-4">
         {/* <!-- price --> */}
         <div className="space-y-2">
          <label htmlFor="price">Price</label>
          <input
           className="addProductInput"
           type="number"
           id="lws-inputPrice"
           name="prodPrice"
           required
          />
         </div>
         {/* <!-- quantity --> */}
         <div className="space-y-2">
          <label htmlFor="quantity">Quantity</label>
          <input
           className="addProductInput"
           type="number"
           id="lws-inputQuantity"
           name="prodQuantity"
           required
          />
         </div>
        </div>
        {/* <!-- submit button --> */}
        <button type="submit" id="lws-inputSubmit" className="submit">
         Add Product
        </button>
       </form>
      </div>
      {/* <!-- Product Input Form Ends --> */}
     </div>
    </div>
   </main>
  </div>
 );
};

export default Products;
